import React, { useState } from "react";
import AIChatWindow from "./AIChatWindow";
import "../styles/aiAssistant.css";
import logo from "../assets/agencybazaar-logo.png";

const AIWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Chat Window */}
      {isOpen && <AIChatWindow onClose={() => setIsOpen(false)} />}

      {/* Floating Button */}
      <div className="ai-widget-wrapper">
        <div className="ai-hover-message">👋 Hi, I'm NISHI</div>

        <div className="ai-floating-button" onClick={() => setIsOpen(!isOpen)}>
          <img src={logo} alt="AgencyBazaar AI" />

          <span className="ai-online-dot"></span>
        </div>
      </div>
    </>
  );
};

export default AIWidget;
